import React from "react"
import { FetchPaymentMethodsPayload } from "braintree-web"
import { FilteredPaymentMethod } from "../../../../types/store/common"
import { CheckoutButton, CheckoutButtonProps } from "../../../checkout/partials/checkout-button"
import { PaymentMethodButton } from "../../../checkout/partials/payment-method-button"
import { PAYMENT_METHOD_IDS } from "../../../../utils/constants"
import { useOrderStore } from "../../../../store/hooks/useStore"
import { usePaymentMethodData } from "../../../../hooks/use-payment-method-data"

interface SummaryButtonsProps extends CheckoutButtonProps {
    paymentMethod: FetchPaymentMethodsPayload | FilteredPaymentMethod
    selectedPayment: string | null
}
export const SummaryButtons = (props: SummaryButtonsProps) => {
    const { isPaymentRequired, editMode } = useOrderStore()
    const { paymentMethod, submitOrderProcess, isPaymentRefunding, braintreeFormIsValid, bonusCardStatus, hostedFieldsErrors, selectedPayment, isTopUp } = props
    const isCard = 'type' in paymentMethod && paymentMethod?.type !== 'PayPalAccount' || ('id' in paymentMethod && paymentMethod.id === PAYMENT_METHOD_IDS.BT_CREDIT_CARD)
    const isSelected = ('id' in paymentMethod && selectedPayment === paymentMethod.id) || ('nonce' in paymentMethod && selectedPayment?.split('_')[1] === paymentMethod.nonce)
    const {
        isAvailable,
        isLoading,
        isDisabled,
        buttonColour
      } = usePaymentMethodData(paymentMethod)
    const id = 'id' in paymentMethod ? paymentMethod.id : 'PayPal'

    return !isAvailable ? <></> : (
        !isPaymentRequired || bonusCardStatus?.hidePayment || isCard ?
            <CheckoutButton
                submitOrderProcess={submitOrderProcess}
                isEditModeEnabled={editMode}
                billingAddressFormValid={true}
                isPaymentRefunding={isPaymentRefunding}
                braintreeFormIsValid={braintreeFormIsValid}
                bonusCardStatus={bonusCardStatus}
                hostedFieldsErrors={hostedFieldsErrors}
                display={isSelected ? 'block' : 'none'}
                isTopUp={isTopUp}
            /> : (
                <PaymentMethodButton
                    containerId={`${id}-container-2`}
                    isLoading={isLoading}
                    disabled={isDisabled}
                    display={isSelected ? 'block' : 'none'}
                    backgroundColor={buttonColour} 
                    data-test-selector={`checkout-pay-with-${id.toLowerCase()}-button-right`}
                    />
            )
    )

}